export const iOSLoginRequest = () => {
  interface IWebViewBridge {
    // eslint-disable-next-line no-unused-vars
    postMessage: (payload: { command: 'iOSLoginBridgeRequest' }) => void;
  }

  // Force cast since WebKit's postMessage differs from DOM's version
  const iOSWebViewBridge = window.webkit?.messageHandlers.iOSWebViewBridge as unknown as IWebViewBridge;
  iOSWebViewBridge.postMessage({ command: 'iOSLoginBridgeRequest' });
};

interface IGatewayTokenPayload {
  command: 'iOSGatewayTokenRequest';
  forceRefresh?: boolean;
}

export const iOSGatewayTokenRequest = ({ forceRefresh = false }: { forceRefresh?: boolean } = {}) => {
  interface IWebViewBridge {
    // eslint-disable-next-line no-unused-vars
    postMessage: (payload: IGatewayTokenPayload) => void;
  }

  const payload: IGatewayTokenPayload = {
    command: 'iOSGatewayTokenRequest',
    ...(forceRefresh ? { forceRefresh } : {}),
  };

  const iOSWebViewBridge = window.webkit?.messageHandlers.iOSWebViewBridge as unknown as IWebViewBridge;
  iOSWebViewBridge.postMessage(payload);
};

interface ILogoutPayload {
  command: 'iOSCloseView';
  expiredSession?: boolean;
  errorMessage?: string;
}

export const iOSLogout = ({ expiredSession = false, errorMessage }: Partial<ILogoutPayload> = {}) => {
  interface IWebViewBridge {
    // eslint-disable-next-line no-unused-vars
    postMessage: (payload: ILogoutPayload) => void;
  }

  const payload: ILogoutPayload = {
    command: 'iOSCloseView',
    expiredSession,
    ...(errorMessage ? { errorMessage } : {}),
  };

  const iOSWebViewBridge = window.webkit?.messageHandlers.iOSWebViewBridge as unknown as IWebViewBridge;
  iOSWebViewBridge?.postMessage(payload);
};
